// Constants
import {
    SHARED_EVENT_LOAD_REQUESTED,
    SHARED_EVENT_LOAD_SUCCEEDED,
    SHARED_EVENT_LOAD_FAILED,
    SHARED_EVENT_LOAD_CANCELED,
    SHARED_EVENT_SET
} from './constants';

// Types
import type { SharedEvent } from './types';

export function requestLoadSharedEvent(eventUuid: number) {
    return {
        type: SHARED_EVENT_LOAD_REQUESTED,
        payload: {
            eventUuid
        }
    };
}

export function succeededLoadSharedEvent(response: Object) {
    return {
        type: SHARED_EVENT_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadSharedEvent(error: Error) {
    return {
        type: SHARED_EVENT_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadSharedEvent() {
    return {
        type: SHARED_EVENT_LOAD_CANCELED,
        payload: {}
    };
}

export function setSharedEvent(data: SharedEvent) {
    return {
        type: SHARED_EVENT_SET,
        payload: data
    };
}
